import {Component, EventEmitter, Input, Output} from '@angular/core';
import { DataService } from 'app/data.service';
import { Form } from '../../create-task/create-task.type';

@Component({
   selector: 'app-document-list',
   templateUrl: './document-list.component.html',
   styleUrls: ['./document-list.component.css']
})
export class DocumentListComponent {

   @Input() documents: any[];
   @Input() formName: string;
   @Input() form: Form;
   @Input() currentActiveIndex: number;

   @Output() listClick = new EventEmitter<{
      index: number;
      docId?: any;
      docName?: any;
      formName?: string;
      form?: Form;
   }>();

   constructor(
      private dataService: DataService
   ) {
      // This is intentional.
   }

   public onListClick(object: {
      index: number;
      docId?: any;
      docName?: any;
      formName?: string;
      form?: Form;
   }) {
      this.listClick.emit(object);
   }

   convertFirstDocToObject(data){
      const firstObject = {docId: data[0].docId,index: 0,docName: data[0].docName}
      this.listClick.emit(firstObject);
   }
}
